export enum AttachmentUploadErrorType {
  General = 'general',
  Size = 'size',
}
